(function () {
  function closeAll() { Array.prototype.forEach.call(document.querySelectorAll('[data-sheet]'), function (s) { s.hidden = true; }); document.documentElement.classList.remove('cc3-lock'); }
  document.addEventListener('click', function (e) {
    var op = e.target.closest('[data-sheet-open]');
    if (op) { var sh = op.closest('[data-card]').querySelector('[data-sheet]'); sh.hidden = false; document.documentElement.classList.add('cc3-lock'); return; }
    if (e.target.closest('[data-sheet-close]')) { closeAll(); return; }
    var sz = e.target.closest('.cc2__size');
    if (sz) {
      var card = sz.closest('[data-card]');
      Array.prototype.forEach.call(card.querySelectorAll('.cc2__size'), function (b) { b.classList.remove('is-on'); });
      sz.classList.add('is-on');
      Array.prototype.forEach.call(card.querySelectorAll('[data-gal]'), function (g) { g.hidden = g.getAttribute('data-gal') !== sz.getAttribute('data-size'); });
      card.querySelector('[data-vid]').value = sz.getAttribute('data-vid');
      var more = card.querySelector('[data-more]'); if (more) more.setAttribute('href', sz.getAttribute('data-url'));
      var add = card.querySelector('[data-add]'), ok = sz.getAttribute('data-ok') !== 'false';
      if (add) { add.disabled = !ok; add.innerHTML = ok ? add.getAttribute('data-add-label') + ' <span data-price>' + sz.getAttribute('data-price') + '</span>' : add.getAttribute('data-sold-label'); }
      return;
    }
    var note = e.target.closest('[data-note]');
    if (note) {
      var c2 = note.closest('[data-card]'), box = c2.querySelector('[data-nbox]'), img = note.getAttribute('data-img');
      Array.prototype.forEach.call(c2.querySelectorAll('[data-note]'), function (n) { n.classList.remove('is-on'); });
      note.classList.add('is-on');
      c2.querySelector('[data-nname]').textContent = note.getAttribute('data-name');
      c2.querySelector('[data-ndesc]').textContent = note.getAttribute('data-desc') || '';
      var ni = c2.querySelector('[data-nimg]'); ni.innerHTML = img ? '<img src="' + img + '" alt="">' : ''; if (!img) ni.textContent = (note.getAttribute('data-name') || '?').charAt(0);
      box.hidden = false;
    }
  });
  document.addEventListener('keydown', function (e) { if (e.key === 'Escape') closeAll(); });
  document.addEventListener('submit', function (e) { if (e.target.matches('[data-cc-form]')) setTimeout(closeAll, 400); });
})();
